import { render, staticRenderFns } from "./form-edit.vue?vue&type=template&id=39ff5b60&scoped=true&"
import script from "./form-edit.vue?vue&type=script&lang=js&"
export * from "./form-edit.vue?vue&type=script&lang=js&"
import style0 from "./form-edit.vue?vue&type=style&index=0&id=39ff5b60&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ff5b60",
  null
  
)

export default component.exports